import classNames from "classnames"
import { FC } from "react"
import { Link } from "react-router"

import styles from "./logo.module.css"
import { ILogoProps } from "./logo.type"
import { Icons } from "../icon/constants"
import Icon from "../icon/Icon"

const Logo: FC<ILogoProps> = ({ className, href, ...rest }) => {
    const logoClassnames = classNames(
        styles.logo,
        className,
    )
    return (
        <Link to={ href } className={styles.logoWrapper}>
            <Icon className={logoClassnames} icon={Icons.BanxeLogo} {...rest}></Icon>
        </Link>
    )
}

export default Logo
